import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { db } from '../../services/db';
import Button from '../../components/common/Button';
import SafeIcon from '../../components/common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const EventsEditor = () => {
  const [event, setEvent] = useState(null);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    db.getEvent().then(setEvent);
  }, []);

  const handleChange = (field, value) => {
    setEvent((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await db.updateEvent(event);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } finally {
      setSaving(false);
    }
  };

  if (!event) return <AdminLayout><div>Loading...</div></AdminLayout>;

  return (
    <AdminLayout>
      <div className="max-w-4xl space-y-6">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 space-y-4">
          <h2 className="text-lg font-bold text-gray-900">Current event</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Title (Spanish)</label>
              <input type="text" value={event.titleEs || ''} onChange={(e) => handleChange('titleEs', e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Title (English)</label>
              <input type="text" value={event.titleEn || ''} onChange={(e) => handleChange('titleEn', e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Date</label>
              <input type="text" value={event.date || ''} onChange={(e) => handleChange('date', e.target.value)} placeholder="YYYY-MM-DD" className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Time</label>
              <input type="text" value={event.time || ''} onChange={(e) => handleChange('time', e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Location</label>
              <input type="text" value={event.location || ''} onChange={(e) => handleChange('location', e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Registration URL</label>
              <input type="url" value={event.registrationUrl || ''} onChange={(e) => handleChange('registrationUrl', e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Description (Spanish)</label>
            <textarea value={event.descriptionEs || ''} onChange={(e) => handleChange('descriptionEs', e.target.value)} rows={2} className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Description (English)</label>
            <textarea value={event.descriptionEn || ''} onChange={(e) => handleChange('descriptionEn', e.target.value)} rows={2} className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
          </div>
          <div className="flex items-center gap-4 pt-4 border-t">
            <Button onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save Event'}</Button>
            {success && <span className="flex items-center gap-2 text-green-600 text-sm"><SafeIcon icon={FiIcons.FiCheck} /> Saved</span>}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default EventsEditor;
